export default __webpack_public_path__ + "static/media/a00187b31dd5a4ece0c8f809b69962eb.06cf36e5.png";